import { Observable } from "rxjs";

import { Provider } from "@angular/core";
import { UseCase } from "../../../../core/use-case";
import { Discipline } from "../../../models/discipline.model";
import { HrRepository } from "../../../repositories/hr.repository";

export class GetAllDisciplinesUseCase implements UseCase<void, Discipline[]> {
  constructor(private repo: HrRepository) {}
  execute(param: void): Observable<Discipline[]> {
    return this.repo.getAllDisciplines();
  }
}

const getAllDisciplinesUseCaseFactory = (repo: HrRepository) =>
  new GetAllDisciplinesUseCase(repo);

export const getAllDisciplinesUseCaseProvider: Provider = {
  provide: GetAllDisciplinesUseCase,
  useFactory: getAllDisciplinesUseCaseFactory,
  deps: [HrRepository],
};
